import { render, staticRenderFns } from "./UEEditor.vue?vue&type=template&id=5acf51ec&scoped=true&"
import script from "./UEEditor.vue?vue&type=script&lang=js&"
export * from "./UEEditor.vue?vue&type=script&lang=js&"
import style0 from "./UEEditor.vue?vue&type=style&index=0&id=5acf51ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acf51ec",
  null
  
)

export default component.exports